// extracted by mini-css-extract-plugin
module.exports = {"Message":"Message__Message__F4NM-","error":"Message__error__14v5t","warning":"Message__warning__cZ9NT","info":"Message__info__2DIl3"};